import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromUserActivityLog from './reducers/user-activity-log.reducer';
import { EffectsModule } from '@ngrx/effects';
import { UserActivityLogEffects } from './effects/user-activity-log.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('UserActivityLog', fromUserActivityLog.reducer),
    StoreModule.forFeature('ProIncomeList', fromUserActivityLog.proIncomeListReducer),
    StoreModule.forFeature('ReportDiscountList', fromUserActivityLog.reportDiscountListReducer),
    EffectsModule.forFeature([UserActivityLogEffects])
  ]
})
export class UserActivityLogModule { }
